import React from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./DateFilter.scss";
import CalendarIcon from "../../icons/calendar.svg";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { enGB } from "date-fns/locale";
import { format } from "date-fns";

// Register the locale that starts weeks on Monday
registerLocale("en-GB", enGB);

const DateFilter = ({
  startDate,
  handleDateFilterChange,
  isClearable,
  maxDate,
}) => {
  const CustomButton = React.forwardRef(({ value, onClick }, ref) => (
    <button type="button" className="customInput" onClick={onClick} ref={ref}>
      {value ? value : "Select Date"}
      <img src={CalendarIcon} alt="Calendar icon" className="calendarIcon" />
    </button>
  ));

  return (
    <DatePicker
      selected={startDate}
      onChange={handleDateFilterChange}
      dateFormat="dd/MM/yyyy"
      locale="en-GB"
      wrapperClassName="datePicker"
      isClearable={isClearable}
      maxDate={maxDate}
      customInput={<CustomButton />}
      enableTabLoop={false}
      renderCustomHeader={({
        date,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
      }) => (
        <div className="datepicker-header">
          <button
            type="button"
            onClick={decreaseMonth}
            disabled={prevMonthButtonDisabled}
            className="nav-btn"
          >
            <ChevronLeft size={16} strokeWidth={1.8} />
          </button>

          <span className="month-label">
            {format(date, "MMMM yyyy", { locale: enGB })}
          </span>

          <button
            type="button"
            onClick={increaseMonth}
            disabled={nextMonthButtonDisabled}
            className="nav-btn"
          >
            <ChevronRight size={16} strokeWidth={1.8} />
          </button>
        </div>
      )}
    />
  );
};

export default DateFilter;
